import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    probePosition: undefined,
    planeDirection: undefined,
    stackCenter: undefined,
    speed: 0.01,
    rotateXZ: 1.5,
    rotateY: 1,
    rotateSolution: 0,
    mouseYRelative: 0.5,
    mouseXRelative: 0.5,
    currentRound: 0,
    currentGame: 0,
    loading: true

  },
  mutations: {
    setProbePosition (state, payload) {
      state.probePosition = payload
    },
    setPlaneDirection (state, payload) {
      state.planeDirection = payload
    },
    setStackCenter (state, payload) {
      state.stackCenter = payload
    },
    setSpeed (state, payload) {
      state.speed = payload
    },
    setRotateXZ (state, payload) {
      state.rotateXZ = payload
    },
    setRotateY (state, payload) {
      state.rotateY = payload
    },
    setRotateSolution (state, payload) {
      state.rotateSolution = payload
    },
    setMouseYRelative (state, payload) {
      state.mouseYRelative = payload
    },
    setMouseXRelative (state, payload) {
      state.mouseXRelative = payload
    },
    setCurrentRound (state, payload) {
      state.currentRound = payload
    },
    setCurrentGame (state, payload) {
      state.currentGame = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    }
  },
  actions: {

  }
})

// nutzung
// console.log(this.$store.state.probePosition)
// this.$store.commit('setProbePosition', 1000)
